module.exports = __webpack_public_path__ + "img/wms.d2cb1ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/trait/wms.png
// module id = og9I
// module chunks = 9